export default "__VITE_ASSET__DE7rq60j__"